<div class="ui-size-shape-info d-flex align-items-center">
  <ui-shape-icon
    class="me-3 shape-icon-wrap"
    [keyword]="size.details.shape"
  ></ui-shape-icon>

  <div>
    <div class="font-xl fw-bold"
         *ngIf="!discount">
      {{size.details.value}} {{size.details.measurement}} - {{size.price | currencyFormat: currency}}
    </div>
    <div class="font-xl fw-bold"
         *ngIf="discount">
      {{size.details.value}} {{size.details.measurement}} -
      <span class="text-muted-warm text-cross-out">{{size.price | currencyFormat}}</span>&nbsp;<span
      [class.text-discount]="!discountTheme.color()"
      [style.color]="discountTheme.color()">{{size.price | tryToDiscountPrice: discount : currency}}</span>
    </div>

    <div class="font-md text-muted-2"
         *ngIf="size.details.definition">
      {{size.details.definition}}
    </div>
  </div>
</div>
